import { InsightsFeature, ViewerFeature } from './types';

export enum FormTypes {
  Assembly = 'ASSEMBLY',
  PaintBlocks = 'PAINT_BLOCKS',
  PointOfInterest = 'POINT_OF_INTEREST',
  Structure = 'STRUCTURE',
  DefectLegends = 'DEFECT_LEGENDS',
  QuerySummary = 'QUERY_SUMMARY',
  RiskConfiguration = 'RISK_CONFIGURATION',
  Logs = 'LOGS',
}

export enum StructureSection {
  StructureDetails = 'structure-details',
  Features = 'features',
  ReportConfig = 'report-config',
  SummaryChartsConfig = 'summary-charts-config',
  StructurePipes = 'structure-pipes',
  NominationPoiTypes = 'nomination-poi-types',
}

export const INSIGHTS_OPTIONS: { label: string; key: InsightsFeature }[] = [
  { label: 'Components Tab', key: 'COMPONENTS_TAB' },
  { label: 'POI Tab', key: 'POINTS_OF_INTEREST_TAB' },
  { label: 'Paint Block Tab', key: 'PAINT_BLOCK_TAB' },
  { label: 'Decks Tab', key: 'DECK_TAB' },
];

export const VIEWER_OPTIONS: { label: string; key: ViewerFeature }[] = [
  { label: 'Deck Filter', key: 'DECK_FILTER' },
  { label: 'Paint Block Filter', key: 'PAINT_BLOCK_FILTER' },
];

export const REPORT_CONFIG_KEYS: string[] = [
  'poi-name',
  'poi-id',
  'workpack-number',
  'is-verified',
  'paint-block',
  'deck',
  'poi-type',
  'accessibility',
];

export const POI_REPORT_OPERATIONAL_TABLE_KEYS: string[] = [
  'components',
  'point_of_interests',
  'paint_blocks',
  'service_group',
  'repair_area',
  'scaffold',
  'pob',
  'man_hours',
];

export interface PoiFieldOption {
  key: string;
  label: string;
  source: 'schema' | 'template';
}

export const POI_SCHEMA_FIELDS: PoiFieldOption[] = [
  { key: 'poi_id', label: 'POI ID', source: 'schema' },
  { key: 'poi_type', label: 'POI Type', source: 'schema' },
  { key: 'name', label: 'POI Name', source: 'schema' },
  { key: 'deck_relative_height', label: 'Deck Relative Height', source: 'schema' },
  { key: 'paint_region', label: 'Paint Region', source: 'schema' },
  { key: 'accessibility', label: 'Accessibility', source: 'schema' },
  { key: 'status', label: 'Status', source: 'schema' },
  { key: 'priority', label: 'Priority', source: 'schema' },
  { key: 'created_at', label: 'Created At', source: 'schema' },
  { key: 'due_date', label: 'Due Date', source: 'schema' },
  { key: 'workpack_number', label: 'Workpack Number', source: 'schema' },
  { key: 'comment', label: 'Comment', source: 'schema' },
  { key: 'sc_category', label: 'SC Category', source: 'schema' },
];
